import { matchPath } from 'react-router';

import { takeLatest, call, put, select, take } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { APPLICATION_IS_READY } from 'modules/app/actionTypes';
import { applicationIsReady, locationHasChanged } from 'modules/app/selectors';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { getLocation, isFirstRendering as isFirstRenderingSelector } from 'modules/router/selectors';
import { createNotification } from 'modules/toast-notifications/actions';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

import {
  getUserGroups,
  getUserGroupsSuccess,
  getUserGroupsFailure,
  updateUserGroupsSuccess,
  updateUserGroupsFailure,
  fetchUserGroupsByDealerIdsSuccess,
  fetchUserGroupsByDealerIdsFailure,
} from './actions';
import * as types from './actionTypes';

function* fetchUserGroups({ payload, meta }) {
  const { request } = payload;
  try {
    const response = yield call(restClient.request, request);
    yield put(getUserGroupsSuccess(response.data, meta));
  } catch (e) {
    yield put(getUserGroupsFailure(e));
  }
}

function* updateUserGroups({ payload, meta }) {
  const { request } = payload;
  try {
    const response = yield call(restClient.request, request);
    yield put(updateUserGroupsSuccess(response.data, meta));
  } catch (e) {
    yield put(updateUserGroupsFailure(e));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'userGroups.update.failure',
          defaultMessage: 'An error occurred while saving users groups.',
        },
      })
    );
  }
}

function* fetchByDealerIds({ payload, meta }) {
  const { request } = payload;
  try {
    const response = yield call(restClient.request, request);
    yield put(fetchUserGroupsByDealerIdsSuccess(response.data, meta));
  } catch (e) {
    yield put(fetchUserGroupsByDealerIdsFailure(e));
  }
}

function* afterChangeDealer() {
  const isReady = yield select(applicationIsReady);
  const { pathname } = yield select(getLocation);
  const match = matchPath(PATH.USER_GROUPS.path, pathname);

  if (match) {
    if (!isReady) {
      yield take(APPLICATION_IS_READY);
    }

    const dealerId = yield select(getSelectedDealerId);
    yield put(getUserGroups(dealerId));
  }
}

/**
 * @param {import('modules/global/generic.types').LocationChangeAction} action
 */
function* onLocationChange() {
  const haveChange = yield select(locationHasChanged);
  const isFirstRendering = yield select(isFirstRenderingSelector);
  if (!isFirstRendering && haveChange) {
    yield call(afterChangeDealer);
  }
}

export default function* userGroupsSagas() {
  yield takeLatest(LOCATION_CHANGE, onLocationChange);
  yield takeLatest(SELECT_DEALER, afterChangeDealer);
  yield takeLatest(types.FETCH_USER_GROUPS_REQUEST, fetchUserGroups);
  yield takeLatest(types.UPDATE_USER_GROUPS_REQUEST, updateUserGroups);
  yield takeLatest(types.FETCH_SELECTED_USER_GROUPS_REQUEST, fetchByDealerIds);
}
